module.exports = __webpack_public_path__ + "img/lookdemo.f5fa8928.svg";